export function objectDeepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (typeof structuredClone === 'function') {
        try {
            return structuredClone(obj);
        }
        catch (error) {
            console.error('Deep clone failed using structuredClone', error);
        }
    }
    try {
        return JSON.parse(JSON.stringify(obj));
    }
    catch (error) {
        console.error('Deep clone failed using JSON fallback.', error);
    }
    return obj;
}
//# sourceMappingURL=obj-clone.js.map